<div class="bg-background-ground px-lg py-md border-stroke-neutral-light flex items-center justify-between border-b">
  <div class="flex">
    @if (canReturn()) {
      <a
        class="mr-sm"
        routerLink="/"
        hlmBtn
        size="icon"
        variant="ghost"
        aria-label="Retourner au tableau de bord"
        hlmTooltipTrigger="Retourner au tableau de bord"
      >
        <ng-icon hlm name="lucideArrowLeft" />
      </a>
    }
    <span class="title-medium-semibold">Le Compas</span>
  </div>
  <app-user-menu />
</div>
